import React from 'react'

import './footer.scss'

import cn from '../../../../commons/src/libs/class-names'
import {mapChildrenWithFragments} from '../../../../commons/src/services/react-children'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    copyline: React.ReactNode
    children: React.ReactNode
  }
>

const Footer = ({className, copyline, children, ...props}: Props) => (
  <div {...props} className={cn('Footer', {}, className)}>
    <span className="Footer__copyline">{copyline}</span>
    <ul className="Footer__linkList">
      {mapChildrenWithFragments(children, (link, index) => (
        <li key={index} className="Footer__link">
          {link}
        </li>
      ))}
    </ul>
  </div>
)

export default Footer
